<template>
    <v-card class="ma-4">
      <v-card-title primary-title class="grey lighten-4">
        <h3 class="title mb-0">Leider noch keine Fachbetriebe verfügbar</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="this.$vuetify.breakpoint.xsOnly">
       <p class="subheading">
         Im Umkreis von 25 km konnten wir leider keine Fachbetriebe finden. Bitte aktivieren Sie Ihre Standortfreigabe.
       </p>
      </v-card-text>
      <v-card-text v-else>
        <p class="subheading">
          Im Umkreis von 25 km konnten wir leider keine Fachbetriebe finden. Bitte aktivieren Sie Ihre Standortfreigabe oder ziehen Sie den Marker auf einen anderen Punkt.
        </p>
      </v-card-text>
    </v-card>

</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>